import React from 'react';
import { Link } from 'react-router-dom';
import { useGetPropertiesQuery, useGetMonetizationConfigQuery } from '../../../features/api/apiSlice';
import Icon from '../../../components/AppIcon';
import PropertyCard from './PropertyCard';
import { isLuxuryListing } from '../../../lib/propertyLabels';

const LuxuryHomes = ({ favoritePropertyIds = [] }) => {
  const { data: monetization } = useGetMonetizationConfigQuery();
  const enabled = monetization?.luxury_homepage_enabled !== false &&
    monetization?.luxury_listings_enabled !== false;
  const { data, isLoading } = useGetPropertiesQuery(
    {
      is_luxury: 1,
      limit: 8,
      offset: 0,
    },
    { skip: monetization && !enabled }
  );

  const properties = (data?.data || []).filter(isLuxuryListing);
  if (!enabled) return null;
  if (!isLoading && properties.length === 0) {
    return null;
  }

  return (
    <section className="pb-12 sm:pb-16">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-700 mb-1">
            Curated collection
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
            Luxury homes
          </h2>
          <p className="text-slate-500 mt-1.5">
            Premium houses and apartments selected by agents. Land is not included.
          </p>
        </div>
        <Link
          to="/property-search-browse?type=luxury"
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-amber-400 text-slate-950 text-sm font-semibold hover:bg-amber-300 transition-colors self-start sm:self-auto"
        >
          Browse luxury
          <Icon name="ArrowRight" size={16} />
        </Link>
      </div>

      {isLoading ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="h-64 rounded-2xl bg-slate-100 animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {properties.slice(0, 8).map((property) => (
            <PropertyCard
              key={property.id}
              property={property}
              isFavorite={favoritePropertyIds.includes(property.id)}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default LuxuryHomes;
